import { AxArtwork } from "@dynata/axiom3";
import unavailableImage from "@dynata/axiom3-images/png/general_stand.png";

// DashboardZeroState component to display when there isn't a dashboard
export function DashboardZeroState() {
  return (
    <AxArtwork
      title="No dashboard"
      image={unavailableImage}
      description="Sorry, this dashboard doesn't exist"
    />
  );
}
